import styled from 'styled-components';
import UIBackButton from 'UIComponents/nav/UIBackButton';
export default styled(UIBackButton).withConfig({
  displayName: "BackButton",
  componentId: "u0h1qg-0"
})(["&&{span{font-size:16px;}}"]);